import React from "react"

import PropTypes from "prop-types"

import Tile from "../../../Tile/tile"
import {TILE_VARIANTS} from "../../../Tile/tile"

const TiledRadioButton = ({checked = false, ...props}) => (
    <Tile
        aria-checked={checked}
        role="radio"
        variant={checked ? TILE_VARIANTS.SMALL_BLUE : TILE_VARIANTS.SMALL}
        {...props}
    />
)

TiledRadioButton.propTypes = {
    checked: PropTypes.bool,
}

export default TiledRadioButton
